package com.swetdot.swetgram.data

// Load IANA rules: without them Kotlin/JS only knows a fixed-offset SYSTEM zone,
// so history and daily-task boundaries would be wrong around daylight-saving changes.
@JsModule("@js-joda/timezone")
@JsNonModule
external object JsJodaTimeZoneModule

@OptIn(ExperimentalJsExport::class)
@JsExport
val swetgramTimeZoneData = JsJodaTimeZoneModule
